module.exports = "/_next/static/images/7815f5dfe350c6949e164779f61414b7-tcv.png.webp";